// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"829d98eb","150":"6424f887","226":"1c4ee7c7","277":"77cce53f","352":"a7d1f55e","423":"da404abf","465":"cf925b34","484":"53c27f39","550":"8aa03596","581":"a1870fb1","673":"87458635","794":"34a333f1","864":"1e34e53a","879":"51e9a696","886":"b679bbcf"}[chunkId] + ".chunk.js";
};